import React from 'react'
import { Typography, makeStyles, Logo, useTranslation } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import { getFeature } from '@paintscout/util/builder'
import { useClientOptions } from '@paintscout/ui-business'

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    '@media print': {
      display: 'none'
    },
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    '& a': {
      textDecoration: 'none',
      color: theme.paintscout.palette.brand.Neutral.P70,
      transition: '0.5s all',
      '& svg': {
        width: 32,
        height: 'auto',
        display: 'inline-block',
        fill: theme.paintscout.palette.brand.Neutral.P70,
        marginBottom: theme.spacing(),
        transition: '0.5s all'
      }
    },
    '& a:hover': {
      color: '#004BB4',
      '& svg': {
        fill: '#004BB4'
      }
    }
  }
}))

function Footer() {
  const classes = useStyles({})
  const { __ } = useTranslation()
  const { options } = useClientOptions()
  const hasWhiteLabelling = getFeature({ options, path: 'whiteLabelling.enabled' })

  if (hasWhiteLabelling) {
    return <div style={{ height: 28 }}></div>
  } else
    return (
      <footer className={classes.footer}>
        <div>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a href="https://www.paintscout.com" target="_blank">
            <Logo />
            <Typography variant={'body1'}>{__('Amazing On-Site Estimation')}</Typography>
          </a>
        </div>
      </footer>
    )
}

export default Footer
